
export const ProURL = "https://dealerwebservice-api.azurewebsites.net/";
export const DevURL = "https://dealerwebservice-api-dev.azurewebsites.net/";
export const POST_SEND_EMAIL = `DealerWebApp/SendMazoAdminEmail`;

export const URL = ProURL;